import {useState} from "react";
import useAsyncEffect from "../../hooks/useAsyncEffect";
import NotificationManager from "../notifications/NotificationManager";

export default function StaticPage(props:{url: string}) {

    const [htmlContent, setHtmlContent] = useState('');

    useAsyncEffect(async () => {
        const fetchHtml = async () => {
            try {
                const response = await fetch(
                    props.url,
                );
                const html = await response.text();
                setHtmlContent(html);
            } catch (error) {
                NotificationManager.error('Error fetching HTML:', error);
            }
        };

        await fetchHtml();
    }, []);

    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
}
